<template>
  <router-view v-slot="{ Component }">
    <Transition>
      <component :key="route.path.split('/').slice(0, 3).join('/')" class="view" :is="Component" />
    </Transition>
  </router-view>
</template>

<script setup>
const route = useRoute()
</script>

<style scoped>
.view {
  width: 100%;
  position: relative;
}

.v-enter-active {
  transition: opacity 400ms ease;
  transition-delay: 200ms;
}

.v-leave-active {
  transition: opacity 200ms ease;
  position: absolute;
  top: 0;
  width: 100%;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
